import React from 'react';

import {FilterInput} from 'src/components/input';

import Label from '@pb/kit-component-label';


type Props = {
    accountName?: string,
    onChange: (accountName: string) => void,
};

export const AccountNameFilter = ({accountName, onChange}: Props) => (
    <div style={{width: 250}}>
        <Label>Account name</Label>
        <FilterInput
            id="account-name"
            value={accountName || ''}
            placeholder="Account name"
            onChange={onChange}
            onClear={() => onChange('')}
            timeOut={500}
        />
    </div>
);
